<template>
  <div v-show="show" class="dutyInfo-container">
      <div class="bg"></div>
      <div v-if="!config.has_foreman_opt_role" class="dutyInfo-content">
          <div class="title">
            <div class="left">值班信息</div>
            <div @click="close" class="close"></div>
          </div>
          <div class="info">
            <div>
              <p>值班长：</p>
              <span>{{config.foreman_config.foreman}}</span>
            </div>
            <div>
              <p>管理员：</p>
              <span>{{config.foreman_config.admin}}</span>
            </div>
          </div>
      </div>
      <div v-else class="dutyInfo-edit">
        <div class="title">值班信息</div>
        <div class="input">
          <div>
            <p>值班长</p>
            <input v-model="config.foreman_config.foreman" maxlength="50" placeholder="请输入值班长" type="text">
          </div>
          <div>
            <p>管理员</p>
            <input v-model="config.foreman_config.admin" maxlength="50" placeholder="请输入管理员" type="text">
          </div>
        </div>
        <div class="btns">
          <div @click="save" class="btn g">保存</div>
          <div @click="close" class="btn">取消</div>
        </div>
      </div>
  </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'

export default {
  name: 'confirm',
  data() {
    return {
      show: true,
      config: {
        foreman_config: {
          foreman: '',
          admin: ''
        },
        has_foreman_opt_role: false,
        nowDate: ''
      },
      r: null
    }
  },
  methods: {
    open(c, r) {
      this.config = JSON.parse(JSON.stringify(c))
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    // confirm() {
    //   this.r(true)
    //   this.close()
    // },
    alpha() {
      this.config.alpha.handle()
      this.r(true)
      this.close()
    },
    beta() {
      this.config.beta.handle()
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    },
    save() {
      let info = {
        foreman: this.config.foreman_config.foreman,
        admin: this.config.foreman_config.admin,
        date: this.config.nowDate
      }
      common.myFetch(apis.newTopicForemanConfig,info).then(res => {
        console.log(res)
        if(res){
          this.$toast(res);
          this.show = false
          this.r(true)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .dutyInfo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999;

    .bg {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);
    }

    .dutyInfo-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 418px;
      height: 230px;
      background: #F9F9F9;
      border-radius: 4px;
      padding: 20px 30px 30px;
      box-sizing: border-box;

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 20px;
          color: #050F0F;
          line-height: 24px;

          &::before {
            display: block;
            content: '';
            width: 4px;
            height: 20px;
            background: #41B48C;
            margin-right: 10px;
          }
        }

        .close {
          display: block;
          width: 16px;
          height: 16px;
          background: url('../../assets/img/common/close.svg') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
        }
      }

      .info {
        width: 100%;
        height: 136px;
        background: rgba(185,195,195,0.15);
        border-radius: 4px;
        padding: 20px;
        box-sizing: border-box;

        div {
          display: flex;
          align-items: center;
          margin-bottom: 26px;

          p {
            min-width: 56px;
            font-weight: bold;
            font-size: 14px;
            color: #050F0F;
            line-height: 20px;
            margin-right: 30px;
            white-space: nowrap;
          }

          span {
            font-weight: 500;
            font-size: 14px;
            color: #323B4B;
            line-height: 20px;
          }
        }
      }
    }

    .dutyInfo-edit {
      width: 418px;
      height: 234px;
      background: #F9F9F9;
      border-radius: 4px;
      padding: 30px;
      box-sizing: border-box;

      .title {
        font-weight: bold;
        font-size: 16px;
        color: #050F0F;
        line-height: 18px;
        margin-bottom: 20px;
      }

      .input {
        display: flex;
        flex-direction: column;

        div {
          display: flex;
          align-items: center;
          margin-bottom: 14px;
          width: 100%;

          &:nth-last-of-type(1) {
            margin-bottom: 26px;
          }
          
          p {
            width: 65px;
            font-weight: bold;
            font-size: 14px;
            color: #050F0F;
            line-height: 20px;
          }

          input {
            flex: 1;
            min-width: 0;
            height: 32px;
            background: rgba(185,195,195,0.2);
            border-radius: 2px;
            outline: none;
            border: none;
            padding: 0 20px;
            box-sizing: border-box;
          }
        }
      }

      .btns {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 32px;
          background: #B9C3C3;
          border-radius: 4px;
          font-weight: bold;
          font-size: 14px;
          color: #FFFFFF;
          user-select: none;
          cursor: pointer;

          &.g {
            background: #41B48C;
            margin-right: 20px;
          }
        }
      }
    }
}
</style>
